import { snackbarService } from '/common/snackbarService';
import { clipboardWrite } from '/helpers';

export const handleCopyClick = () => {
  clipboardWrite(window.location.href);
  snackbarService.success('Copied link');
};
